// new related products
    var loadRelatedProducts = function() {
        var container = $(document).find('.related-products');
        // if( container.length < 1 ) {
        //     console.log('related-products not found');
        //     return;
        // }

        var innerContainer = container.find('.collection__items ');

        // Read product id from data attribute
        var productId = container.attr('data-product-id');

        // Build request URL
        var requestUrl = "https://shopify.lita-app.com/related-products/"+productId;
        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();
        var finalData = '';
        var jsonData = '';
        request.open("GET", requestUrl);

        request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
                jsonData = JSON.parse(request.response);
                // container.innerHTML = request.response;
                // productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

                if(parseInt(jsonData.status.count) < 1 || jsonData.status.message !== "") {
                  finalData += `<p class="no-related-products">There are no similar releases available</p>`;
  
                  $('.spinner').fadeOut('slow');
                  innerContainer.html(finalData);
                  
                  return;
                }

                for (var i = 0; i < jsonData.items.length; i++) {
                    var item = jsonData.items[i];
                    // console.log(item);

                    finalData += `
                        <a class="collection__item"
                        href="${item.url}">
                        <div class="collection__image position-relative d-flex align-content-center">
                            <img src="${item.image[0]}"
                                alt="${item.title}">
                
                            <div class="collection__image-btn position-absolute align-items-center justify-content-center">
                                <button class="btn btn-white btn-hover-light btn-md fw-med text-uppercase">View Product</button>
                            </div>
                        </div>
                
                        <div class="collection__artist text-center">
                            <h6>${item.primary_artist}</h6>
                        </div>
                
                        <div class="collection__artist text-center">
                            <p>${item.title}</p>
                        </div>
                    </a>
                    `;
                } 

                $('.spinner').fadeOut('slow');
                innerContainer.html(finalData);       
            }
        }
            request.send();
    };
      
    $(document).ready(function(){
        loadRelatedProducts();
    });